module.exports = __webpack_public_path__ + "f49ea1f6f0ffcd9681b51e9b68c06fe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/Lankenau2.jpg
// module id = 888
// module chunks = 0